import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import THEME from 'theme';
import { Heading, Text, Icon } from 'components/chroma';
import { productDisclosureStatementUrl } from 'scenes/common/helpers/contacts';
import { replaceSpaces } from 'scenes/common/helpers/text';
import {
  compCoveredDetails,
  CompCoveredDetail,
} from './ComprehensiveDetailsData';

const Wrapper = styled.div`
  display: flex;
`;

const StyledTable = styled.table`
  td {
    padding: 1rem;
  }
  tr {
    :nth-child(2n + 1) {
      background-color: ${THEME.BACKGROUND.HEADING};
    }
  }
`;

const IncludedIcon = styled(Icon)`
  display: inline;
  color: ${THEME.ICON.VALID};
`;

const DisclaimersWrapper = styled.div`
  margin-top: 2rem;
`;

const TableRow: FunctionComponent<{
  compCoveredDetail: CompCoveredDetail;
}> = ({ compCoveredDetail: { label, description } }) => (
  <>
    <tr id={replaceSpaces(label)}>
      <td>
        <Wrapper>
          <IncludedIcon name="check" ariaLabel="Included" />
          <div>
            <Text weight={700} margin={{ bottom: 0, left: 2 }}>
              {label}
            </Text>
            <Text margin={{ bottom: 0, left: 2 }}>{description}</Text>
          </div>
        </Wrapper>
      </td>
    </tr>
  </>
);

export const CompCoveredDetails: FunctionComponent = () => (
  <>
    <Heading size={4} margin={{ bottom: 2 }}>
      You&apos;ll be covered for:
    </Heading>
    <StyledTable>
      <tbody>
        {compCoveredDetails.map((compCoveredDetail) => (
          <TableRow
            key={replaceSpaces(compCoveredDetail.label)}
            compCoveredDetail={compCoveredDetail}
          />
        ))}
      </tbody>
    </StyledTable>
    <DisclaimersWrapper>
      <Text>
        High level summary only. For full terms, product limits and conditions,
        please see{' '}
        <a
          href={productDisclosureStatementUrl()}
          target="_blank"
          rel="noopener noreferrer"
        >
          Product Disclosure Statement
        </a>
        .
      </Text>
    </DisclaimersWrapper>
  </>
);

export default CompCoveredDetails;
